import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Container, Row, Col, Form, Table } from "react-bootstrap";
import PropTypes from "prop-types";
import PropertyClosedWorkOrder from "./PropertyClosedWorkOrder";
import "./PropertyClosedWorkOrders.css";

function PropertyClosedWorkOrders({ closedWorkOrders }) {
  const location = useLocation();

  useEffect(() => {}, [location]);

  const view = (
    <Container className="coreContent mt-4">
      <Row>
        <Col>
          <Form.Label className="form-label-heading">
            Completed Work Orders
          </Form.Label>
        </Col>
      </Row>
      <Row>
        <Col>
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>Reference</th>
                <th>Created</th>
                <th>Closed</th>
                <th>Type</th>
                <th>Category</th>
                <th>Sub-Category</th>
                <th>State</th>
              </tr>
            </thead>
            <tbody>
              {closedWorkOrders.map((closedWorkOrder) => (
                <PropertyClosedWorkOrder
                  key={closedWorkOrder.id}
                  closedWorkOrder={closedWorkOrder}
                />
              ))}
            </tbody>
          </Table>
        </Col>
      </Row>
    </Container>
  );

  return view;
}

PropertyClosedWorkOrders.propTypes = {
  closedWorkOrders: PropTypes.arrayOf(PropTypes.shape({ id: PropTypes.string }))
    .isRequired,
};

export default PropertyClosedWorkOrders;
